import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import currency from "currency.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import Avatar from "../../common/Avatar";
import { Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import "../../styles.css";
import moment from "moment";
import axios from "axios";
import { useToasts } from "react-toast-notifications";
import { Form } from 'react-bootstrap';
import { ROLES } from "../../utils/constants";
import { TextareaAutosize, TextField } from '@mui/material';

const columnHeaders = [
    { label: "Username", name: "login", width: "15%", align: "left" },
    { label: "Email", name: "email", width: "10%", align: "left" },
    { label: "User ID", name: "id", width: "8%", align: "left" },
    { label: "Sign Up Date", name: "registered", width: "10%", align: "left" },
    { label: "CC Verify", name: "ccver_per_user", width: "10%", align: "left" },
    { label: "CC Verified", name: "cc_verified", width: "10%", align: "left" },
    { label: "Creator Status", name: "c_status", width: "10%", align: "left" },
    { label: "Subs", name: "followers_count", width: "5%", align: "left" },
    { label: "Price", name: "creator_sum_subscription_price", width: "5%", align: "right" },
    { label: "Total Earnings", name: "earnings_sum_pu_total", width: "10%", align: "right" },
    { label: "Total Chargebacks", name: "chargebacks_sum_amount", width: "10%", align: "right" },
    { label: "Referral Income", name: "referral_income", width: "10%", align: "right" },
    { label: "PUs", name: "followings_count", width: "5%", align: "center" },
    { label: "Paid to PUs", name: "paid_to_pus_sum_pu_total", width: "8%", align: "right" },
    { label: "Customer ID", name: "stripe_cust", width: "12%", align: "left" },
];

const UsersTable = (props) => {
    const {
        users,
        pageItems,
        page,
        total,
        orderBy,
        isBusy,
        setPage,
        setOrderBy,
        login,
        setLogin,
        setSearch,
        setSearchBy,
        searchBy,
        getUsers,
        setFetchTrigger,
        fetchTrigger,
        setCcVerified,
        ccVerified
    } = props;

    const { addToast } = useToasts();

    const [activeUser, setActiveUser] = useState({});
    const [username, setUsername] = useState('');
    const [pwd, setPwd] = useState('');
    const [email, setEmail] = useState('');
    const [banned, setBanned] = useState('');
    const [errors, setErrors] = useState({
        login: '',
        pwd: '',
        email: ''
    });
    const [submitting, setSubmitting] = useState(false);
    const [cc_verification, setcc_verification] = useState('');
    const [creatorStatus, setCreatorStatus] = useState('active');
    const [payoutverified, setPayoutverified] = useState('');
    const [bannedMessage, setBannedMessage] = useState('');

    const handleNextPage = () => {
        if (users.current_page < users.last_page)
            setPage(users.current_page + 1);
        setFetchTrigger(fetchTrigger => fetchTrigger + 1);
    };

    const handleLastPage = () => {
        setPage(users.last_page);
        setFetchTrigger(fetchTrigger => fetchTrigger + 1);
    };

    const handlePrevPage = () => {
        if (users.current_page > 1)
            setPage(users.current_page - 1);
        setFetchTrigger(fetchTrigger => fetchTrigger + 1);
    };

    const handleFirstPage = () => {
        setPage(1);
        setFetchTrigger(fetch);
        setFetchTrigger(fetchTrigger => fetchTrigger + 1);
    };

    const attemptSwitch = (id) => {
        switchUser(id);
        // axios.post("/api/administration/attempt/switch")
        //     .then((response) => {
        //         // switchUser(id);
        //     })
        //     .catch((error) => {
        //         console.log(error);
        //     });
    };

    const switchUser = async (id) => {
        const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        await axios.post("/api/switch/user", {
            id: id,
            tz: localTz
        })
            .then((response) => {
                localStorage.setItem('intended', window.location.pathname);
                localStorage.setItem('loggedin_user', response.data.user.id);
                localStorage.setItem('loggedin_access_token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                localStorage.setItem('switch_token', response.data.switch_token);

                window.location = `/home`;
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                console.log('done switching');
            });
    };

    const PaginationContainer = () => {
        const isPrevDisabled = page > 1 ? false : true;
        const isNextDisabled = page < users.last_page ? false : true;
        const handleManualPage = (e) => {
            setPage(e.target.value);
            setFetchTrigger(fetchTrigger => fetchTrigger + 1);
        };
        return (
            <Pagination
                style={{ justifyContent: "flex-end", alignItems: "center" }}
            >
                <span className="mr-3">
                    {total} item{total > 1 ? "s" : ""}
                </span>
                <Pagination.First
                    disabled={isPrevDisabled}
                    className="mr-1"
                    onClick={handleFirstPage}
                />
                <Pagination.Prev
                    disabled={isPrevDisabled}
                    onClick={handlePrevPage}
                />
                <div className="mx-2 d-flex flex-row align-items-center justify-content-center w-auto">
                    <div className="mr-1" style={{ width: 35 }}>
                        <input
                            type="text"
                            className="pagination-input"
                            onChange={handleManualPage}
                            value={page}
                        />
                    </div>
                    of {pageItems}
                </div>
                <Pagination.Next
                    disabled={isNextDisabled}
                    onClick={handleNextPage}
                />
                <Pagination.Last
                    disabled={isNextDisabled}
                    className="ml-1"
                    onClick={handleLastPage}
                />
            </Pagination>
        );
    };

    const SearchUserContainer = () => {
        const handleSearch = () => {
            setPage(1);
            setSearch(login);
            setFetchTrigger(fetchTrigger => fetchTrigger + 1);
        };
        const handleSearchByEmail = () => {
            setSearchBy('email');
            setOrderBy({
                header: "email", //login, email, id, registered, subs, price, total earnings, referral income, pus, paid to pus, customer ID
                order: "ASC", // ASC OR DESC
            });
        };
        const clearSearchText = () => {
            setLogin('');
        };
        return (
            <div className="my-2 mb-4">
                <div className="d-flex">
                    <div className="mr-1 top-3">
                        <input
                            type="text"
                            placeholder="Search username"
                            className="search-user-input"
                            onChange={(e) => setLogin(e.target.value)}
                            value={login}
                        />
                        {
                            login && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
                        }
                    </div>

                    <Button
                        variant="primary"
                        disabled={isBusy}
                        onClick={handleSearch}
                    >
                        {isBusy ? "Searching..." : "Search Users"}
                    </Button>
                </div>

                <div className="mt-1">
                    <div className="form-check form-check-inline">
                        <input
                            name="searchBy"
                            className="form-check-input"
                            type="radio"
                            id="searchByLogin"
                            value="login-email"
                            onChange={() => setSearchBy('login-email')}
                            checked={searchBy == 'login-email'}
                        />
                        <label className="form-check-label" htmlFor="searchByLogin">Login & Email</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            name="searchBy"
                            className="form-check-input"
                            type="radio"
                            id="searchByLogin"
                            value="login"
                            onChange={() => setSearchBy('login')}
                            checked={searchBy == 'login'}
                        />
                        <label className="form-check-label" htmlFor="searchByLogin">Login</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            name="searchBy"
                            className="form-check-input"
                            type="radio"
                            id="searchByEmail"
                            value="email"
                            onChange={handleSearchByEmail}
                            checked={searchBy == 'email'}
                        />
                        <label className="form-check-label" htmlFor="searchByEmail">Email</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            name="searchBy"
                            className="form-check-input"
                            type="checkbox"
                            id="ccVerified"
                            checked={ccVerified}
                            onChange={() => setCcVerified(ccVerified => !ccVerified)}
                        />
                        <label className="form-check-label" htmlFor="ccVerified">CC Being Verified</label>
                    </div>
                </div>
            </div>
        );
    };

    const ColumnContainer = () => {
        return (
            <tr>
                {columnHeaders.map((header, index) => {
                    return (
                        <th
                            className="border-top-0"
                            style={{ width: header.width, textAlign: header.align }}
                            key={index}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOrderBy(header.name, orderBy.order);
                                }}>
                                <span style={{ color: "black" }}>
                                    {header.label}
                                    {orderBy.header === header.name && (
                                        <FontAwesomeIcon
                                            className="ml-2"
                                            color="#0097FE"
                                            icon={[
                                                "fas",
                                                orderBy.order === "DESC"
                                                    ? "chevron-down"
                                                    : "chevron-up",
                                            ]} />
                                    )}
                                </span>

                            </a>
                        </th>
                    );
                })}
            </tr>
        );
    };

    const handleOrderBy = (header, order) => {
        order = order === "ASC" || orderBy.header != header ? "DESC" : "ASC";
        setOrderBy({
            ...orderBy,
            header: header,
            order: order,
        });
        setFetchTrigger(fetchTrigger => fetchTrigger + 1);
    };

    const handleEdit = (user) => {
        setActiveUser(user);
    };

    const handleClose = () => {
        setActiveUser({});
        setErrors({});
    };

    const handleCreatorStatus = () => {
        if (creatorStatus === 'active') {
            setCreatorStatus('inactive');
        } else {
            setCreatorStatus('active');
        }
    };

    const handlePayoutverified = (e) => {
        setPayoutverified(payoutverified => !payoutverified);
    };

    useEffect(() => {
        if (activeUser && Object.keys(activeUser).length > 0) {
            console.log("🚀 ~ useEffect ~ activeUser:", activeUser);
            setUsername(activeUser.login);
            setEmail(activeUser.email);
            setBanned(activeUser.banned);
            setcc_verification(activeUser.ccver_per_user);
            setBannedMessage(activeUser.notes.length > 0 ? activeUser.notes[0].note : '');

            if (activeUser.creator) {
                setCreatorStatus(activeUser.creator.c_status);
                setPayoutverified(activeUser.creator.payoutverified);
            } else {
                setCreatorStatus('active');
            }

        } else {
            setLogin('');
            setPwd('');
            setEmail('');
            setBanned('');
            setcc_verification('');
        }
    }, [activeUser]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setErrors({
            login: '',
            pwd: '',
            email: '',
            banned: '',
            payoutverified: '',
        });
        await axios.patch('/api/administration/users', {
            login: username,
            email,
            pwd,
            banned,
            id: activeUser.id,
            cc_verification: cc_verification,
            c_status: creatorStatus,
            payoutverified: payoutverified,
            banned_message: bannedMessage
        })
            .then(response => {
                getUsers();
                setSubmitting(false);
                addToast('Account successfully updated', { appearance: 'success', autoDismiss: true });

                if (banned) {
                    setCreatorStatus('suspended');
                }
            })
            .catch(error => {
                setSubmitting(false);
                if (error.response.status == 422) {
                    Object.keys(error.response.data.errors).forEach((key) => {
                        setErrors({
                            [key]: error.response.data.errors[key][0]
                        });
                    });
                } else {
                    addToast('Unable to update account details', { appearance: 'error', autoDismiss: true });
                }
            });
    };

    const handleLoginChange = (e) => {
        e.preventDefault();
        setUsername(e.target.value);
        setErrors({
            ...errors,
            login: ''
        });
    };

    const handleEmailChange = (e) => {
        e.preventDefault();
        setEmail(e.target.value);
        setErrors({
            ...errors,
            email: ''
        });
    };

    const handlePasswordChange = (e) => {
        e.preventDefault();
        setPwd(e.target.value);
        setErrors({
            ...errors,
            pwd: ''
        });
    };

    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const handleLogoutUser = async () => {
        setIsLoggingOut(true);
        await axios.post('/api/administration/users/logout', {
            id: activeUser.id
        }).then(response => {
            setIsLoggingOut(false);
            addToast('User successfully logged out', { appearance: 'success', autoDismiss: true });
        }).catch(error => {
            setIsLoggingOut(false);
            addToast('Unable to logout user', { appearance: 'error', autoDismiss: true });
        });
    };

    const [isDeleting, setIsDeleting] = useState(false);
    const handleDeleteUser = () => {
        setIsDeleting(true);
        axios.delete(`/api/administration/users/${activeUser.id}`).then(response => {
            setIsDeleting(false);
            addToast('User successfully deleted', { appearance: 'success', autoDismiss: false });
        }).catch(error => {
            setIsDeleting(false);
            addToast('Unable to delete user', { appearance: 'error', autoDismiss: true });
        });
    };

    const [isDeletingUserContent, setIsDeletingUserContent] = useState(false);
    const handleDeleteUserContent = () => {
        setIsDeletingUserContent(true);
        axios.delete(`/api/administration/users/${activeUser.id}/contents`)
            .then(response => {
                setIsDeletingUserContent(false);
                addToast('User successfully deleted user and contents', { appearance: 'success', autoDismiss: false });
            }).catch(error => {
                setIsDeletingUserContent(false);
                addToast('Unable to delete user and contents', { appearance: 'error', autoDismiss: true });
            });
    };

    const handleCCVerification = () => {
        setcc_verification(cc_verification => !cc_verification);
    };

    const handleBannedChange = () => {
        setBanned(banned => !banned);
    };

    const renderCcVerify = (user) => {

        // exclude PU and Admin
        if ([ROLES.PU, ROLES.ADMIN].includes(user.role)) {
            return "-";
        }

        return user.ccver_per_user || user.radar_fraud_factor ? "Enabled" : "Disabled";
    };

    const renderCcVerified = (user) => {

        if ([ROLES.PU, ROLES.ADMIN].includes(user.role)) {
            return "-";
        }

        switch (user.cc_verified) {
            case 0: return "No";
            case 1: return "Pending";
            case 2: return "Yes";
            default: return "-";
        }
    };

    const handleBannedMessageChange = e => {
        setBannedMessage(e.target.value);
    };

    useEffect(() => {
        if (banned) {
            setCreatorStatus('suspended');
        }

        return () => {

        };
    }, [banned]);


    return (
        <div className="w-100">
            <Modal
                show={activeUser && Object.keys(activeUser).length > 0}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="edit-user-modal"
            >
                <div style={{ padding: '12px' }}>
                    <form>
                        <div className="form-group">
                            <label htmlFor="username">Login Username</label>
                            <input
                                type="text"
                                className={`form-control col-md-8 col-sm-12${errors.login ? ' is-invalid' : ''}`}
                                id="username"
                                placeholder="Login"
                                value={username}
                                onChange={handleLoginChange}
                                size="50"
                            />
                            <div className="invalid-feedback">
                                {errors.login}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="text"
                                className={`form-control col-md-8 col-sm-12${errors.pwd ? ' is-invalid' : ''}`}
                                id="password"
                                placeholder="Enter password"
                                value={pwd}
                                onChange={handlePasswordChange}
                                size="50"
                            />
                            <div className="invalid-feedback">
                                {errors.pwd}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email address</label>
                            <input
                                type="email"
                                className={`form-control col-md-10 col-sm-12${errors.email ? ' is-invalid' : ''}`}
                                id="email"
                                placeholder="Enter email"
                                value={email}
                                onChange={handleEmailChange}
                            />
                            <div className="invalid-feedback">
                                {errors.email}
                            </div>
                        </div>

                        <div className="form-group">
                            {
                                activeUser.role === ROLES.PU && <Form.Check
                                    type="checkbox"
                                    id={`payoutverified-${activeUser.id}`}
                                    className="form-check"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingLeft: 0
                                    }}
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        name="payoutverified"
                                        onChange={handlePayoutverified}
                                        style={{
                                            position: 'relative',
                                            width: 20,
                                            height: 20,
                                            margin: 0
                                        }}
                                        checked={payoutverified}
                                    />
                                    <Form.Check.Label className="ml-2">
                                        Payout Verified
                                    </Form.Check.Label>
                                </Form.Check>
                            }
                            {
                                activeUser.role === ROLES.PU && <Form.Check
                                    type="checkbox"
                                    id={`cStatus-${activeUser.id}`}
                                    className="form-check"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingLeft: 0
                                    }}
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        name="creator-status"
                                        onChange={handleCreatorStatus}
                                        style={{
                                            position: 'relative',
                                            width: 20,
                                            height: 20,
                                            margin: 0
                                        }}
                                        checked={creatorStatus === 'active'}
                                    />
                                    <Form.Check.Label className="ml-2">
                                        Creator Status (Checked is active)
                                    </Form.Check.Label>
                                </Form.Check>
                            }
                            <Form.Check
                                type="checkbox"
                                id={`banned-${activeUser.id}`}
                                className="form-check"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingLeft: 0
                                }}
                            >
                                <Form.Check.Input
                                    type="checkbox"
                                    name="banned"
                                    onChange={handleBannedChange}
                                    style={{
                                        position: 'relative',
                                        width: 20,
                                        height: 20,
                                        margin: 0
                                    }}
                                    checked={banned}
                                />
                                <Form.Check.Label className="ml-2">
                                    Ban user (Also Suspends Creator Status)
                                </Form.Check.Label>
                            </Form.Check>

                            <div className="form-group">
                                <label htmlFor="bannedMessage">Default message for banned user ("Account suspended")</label>
                                <TextareaAutosize
                                    className={`form-control col-md-10 col-sm-12${errors.banned_message ? ' is-invalid' : ''}`}
                                    id="bannedMessage"
                                    placeholder=""
                                    value={bannedMessage}
                                    onChange={handleBannedMessageChange}
                                    minRows={1}
                                />
                                <div className="invalid-feedback">
                                    {errors.banned_message}
                                </div>
                            </div>

                            <Form.Check
                                type="checkbox"
                                id={`cc-verification-${activeUser.id}`}
                                style={{ display: 'flex', alignItems: 'center', paddingLeft: 0 }}
                            >
                                <Form.Check.Input
                                    type="checkbox"
                                    name="cc_verification"
                                    onChange={handleCCVerification}
                                    style={{
                                        position: 'relative',
                                        width: 20,
                                        height: 20,
                                        margin: 0
                                    }}
                                    checked={cc_verification}
                                />
                                <Form.Check.Label className="ml-2">
                                    Verify Credit Card
                                </Form.Check.Label>
                            </Form.Check>
                        </div>
                    </form>

                    <div className="my-2 d-flex justify-content-start edit-user-actions">
                        <Button variant="primary" onClick={handleLogoutUser} disabled={isLoggingOut}>
                            {
                                isLoggingOut ? 'Logging out user...' : 'Logout User'
                            }
                        </Button>
                        <Button variant="primary" onClick={handleDeleteUser} disabled={isDeleting}>
                            {
                                isDeleting ? 'Deleting user...' : 'Delete User'
                            }
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleDeleteUserContent}
                            // disabled={isDeletingUserContent}
                            disabled
                            title="Under construction"
                        >
                            {
                                isDeletingUserContent ? 'Deleting user...' : 'Delete User + Content'
                            }
                        </Button>
                    </div>
                </div>

                <Modal.Footer>
                    <Button variant="light" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleUpdate} disabled={submitting}>
                        {
                            submitting ? 'Submitting...' : 'Submit'
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="d-flex flex-row align-items-center justify-content-between">
                {SearchUserContainer()}

                {total > 0 && (
                    <div className="text-right my-2">
                        {PaginationContainer()}
                    </div>
                )}
            </div>

            {total > 0 && (
                <>
                    <div className="pu-table-container">
                        <Table size="sm" striped hover responsive className="mb-0">
                            <thead>
                                <ColumnContainer />
                            </thead>

                            <tbody>
                                {users.data.map((user, index) => {
                                    return (
                                        <tr key={index} className={`user-table-row${user.deleted_at ? ' bg-warning' : ''}`}>
                                            <td className="text-secondary d-flex flex-row align-items-center">
                                                <div className="mr-1" style={{ width: '10%' }}>
                                                    <Avatar pu={user} />
                                                </div>
                                                <div className="d-flex flex-column align-self-baseline">
                                                    <Link to={`/${user.login}`}>
                                                        <span>{user.login}</span>
                                                    </Link>
                                                    <div style={{ display: 'inline-flex' }}>
                                                        <button className="switch-user-btn border-0" onClick={() => attemptSwitch(user.id)}>Switch To</button>
                                                        <button className="switch-user-btn border-0 mx-3" onClick={() => handleEdit(user)}>
                                                            Edit
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="text-secondary">
                                                {user.email}
                                            </td>
                                            <td className="text-secondary">
                                                {user.id}
                                            </td>
                                            <td className="text-secondary">
                                                {user.registered
                                                    ? moment(
                                                        user.registered,
                                                        "YYYY-MM-DD"
                                                    ).format("DD MMM YYYY")
                                                    : ""}
                                            </td>
                                            <td>
                                                {
                                                    renderCcVerify(user)
                                                }
                                            </td>
                                            <td>{renderCcVerified(user)}</td>
                                            <td>{user.creator ? user.creator.c_status : ''}</td>
                                            <td>{user.followers_count}</td>
                                            <td className="text-right">
                                                {user.creator
                                                    ? currency(
                                                        user.creator
                                                            .subscription_price
                                                    ).format()
                                                    : "--"}
                                            </td>
                                            <td className="text-right">
                                                {currency(
                                                    user.earnings_sum_pu_total
                                                ).format()}
                                            </td>
                                            <td className="text-right">{currency(user.chargebacks_sum_amount).format()}</td>
                                            <td className="text-right">{
                                                currency(parseFloat(user.transaction_referrals1_sum_ru_total ?? 0) + parseFloat(user.transaction_referrals2_sum_ru_total ?? 0)).format()
                                            }</td>
                                            <td className="text-center">{user.followings_count}</td>
                                            <td className="text-right">
                                                {currency(
                                                    user.paid_to_pus_sum_pu_total
                                                ).format()}
                                            </td>
                                            <td>{user.stripe_cust}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>

                            <tfoot>
                                <ColumnContainer />
                            </tfoot>
                        </Table>
                    </div>
                    <div className="text-right my-3">
                        {PaginationContainer()}
                    </div>
                </>
            )}
        </div>
    );
};

export default UsersTable;
